//alert css
const Alert = 
{
    offset: 65,
    position: 'top left',
    theme: 'dark',
    time: 1000,
    transition: 'scale'
}
export default Alert  


// WEBPACK FOOTER //
// ./src/components/Common/Alert.js